import React from 'react';
import { useI18n } from '@/lib/i18n';

export default function Team() {
  const { t } = useI18n();
  return (
    <section id="team" data-testid="team-section" className="bg-white py-24 md:py-32 relative">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-2xl">
          <div className="eyebrow text-[#C5A059] flex items-center gap-3">
            <span className="w-10 h-px bg-[#C5A059]" />
            {t.team.eyebrow}
          </div>
          <h2 className="heading-display mt-6 text-[#0A1128] text-3xl sm:text-4xl lg:text-5xl">{t.team.title}</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 mt-16">
          {t.team.members.map((m, i) => (
            <article
              key={i}
              data-testid={`team-card-${i}`}
              className="group bg-white border border-[#E2E8F0] hover:border-[#C5A059] transition-colors duration-500 overflow-hidden"
            >
              <div className="relative aspect-[4/5] overflow-hidden bg-[#0A1128]">
                {m.photo ? (
                  <img
                    src={m.photo}
                    alt={m.name}
                    data-testid={`team-photo-${i}`}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                    loading="lazy"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-[#0A1128] to-[#12161F]" data-testid={`team-initials-${i}`}>
                    <span className="font-display text-[#C5A059] text-[8rem] leading-none">{m.initials}</span>
                  </div>
                )}
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0A1128]/95 via-[#0A1128]/50 to-transparent pt-32 pb-8 px-8">
                  <div className="eyebrow text-[#C5A059]">{m.role}</div>
                  <h3 className="font-display text-2xl lg:text-3xl text-white mt-2 leading-tight">{m.name}</h3>
                </div>
              </div>
              <div className="p-8 lg:p-10">
                <p className="text-[#1E2229]/75 leading-relaxed">{m.bio}</p>
                <div className="mt-6 h-px w-12 bg-[#E2E8F0] group-hover:w-24 group-hover:bg-[#C5A059] transition-all duration-500" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
